const ww = window.innerWidth
const wh = window.innerHeight

// 场景一计算
const s1Static1W = wh * 0.43 * 2091 / 1051
const s1Static2W = wh * 0.63 * 4013 / 1546
const s1Static2X = s1Static1W > ww ? ww : (s1Static1W - s1Static2W * 0.18)
// 自行车
const s1BikeW = wh * 0.276 * 900 / 673
const s1BikeX = 0.44
const s1Wheel1X = s1BikeX - (s1BikeW * 0.251 / ww)
const s1Wheel2X = s1BikeX + (s1BikeW * 0.485 / ww)
const s1HandX = s1BikeX - (s1BikeW * 0.3 / ww)
const s1LegX = s1BikeX + (s1BikeW * 0.057 / ww)
const s1MotherX = s1BikeX + (s1BikeW * 0.1067 / ww)

const sprites = {
  // 场景一
  s1_cloud2: {
    size: { mode: 'heightFit', height: 0.6847 },
    position: { x: 0, y: 0 },
    anchor: 'topLeft'
  },
  s1_cloud3: {
    size: { mode: 'heightFit', height: 0.5 },
    position: { x: 1, y: 0.1 },
    anchor: 'topLeft'
  },
  s1_ground1: {
    key: 's1_ground',
    size: { mode: 'heightFit', height: 0.32 },
    position: { x: 0, y: 0.68 },
    anchor: 'topLeft'
  },
  s1_ground2: {
    key: 's1_ground',
    size: { mode: 'heightFit', height: 0.32 },
    position: { x: 1, y: 0.68 },
    anchor: 'topLeft'
  },
  s1_static1: {
    size: { mode: 'heightFit', height: 0.43 },
    position: { x: 0, y: 0.71 },
    anchor: 'bottomLeft'
  },
  s1_static3: {
    size: { mode: 'heightFit', height: 0.61 },
    position: { x: 1, y: 0.71 },
    anchor: 'bottomLeft'
  },
  s1_static2: {
    size: { mode: 'heightFit', height: 0.63 },
    position: { x: s1Static2X, y: 0.78 },
    anchor: 'bottomLeft'
  },
  s1_water1: {
    size: { mode: 'heightFit', height: 0.12 },
    position: { x: 1, y: 0.84 },
    anchor: 'topLeft'
  },
  s1_shadow: {
    size: { mode: 'heightFit', height: 0.012 },
    position: {
      x: 1, y: 0.738
    },
    anchor: 'bottom'
  },
  s1_walk: {
    key: 's1_walk1',
    size: { mode: 'heightFit', height: 0.13 },
    position: {
      x: 1, y: 0.73
    },
    anchor: 'bottom'
  },
  s1_shadow2: {
    size: { mode: 'heightFit', height: 0.024 },
    position: {
      x: 0.5, y: 0.86
    },
    anchor: 'top'
  },
  s1_hand: {
    size: { mode: 'heightFit', height: 0.067 },
    position: {
      x: s1HandX, y: 0.64
    },
    anchor: 'bottomRight'
  },
  s1_wheel1: {
    size: { mode: 'heightFit', height: 0.171 },
    position: {
      x: s1Wheel1X, y: 0.79
    },
    anchor: 'center'
  },
  s1_wheel2: {
    size: { mode: 'heightFit', height: 0.171 },
    position: {
      x: s1Wheel2X, y: 0.79
    },
    anchor: 'center'
  },
  s1_bike: {
    size: { mode: 'heightFit', height: 0.276 },
    position: {
      x: s1BikeX, y: 0.553
    },
    anchor: 'top'
  },
  s1_leg: {
    key: 's1_leg1',
    size: { mode: 'heightFit', height: 0.2652 },
    position: {
      x: s1LegX, y: 0.591
    },
    anchor: 'top'
  },
  s1_mother: {
    size: { mode: 'heightFit', height: 0.221 },
    position: {
      x: s1MotherX, y: 0.45
    },
    anchor: 'top'
  },
  s1_water2: {
    size: { mode: 'heightFit', height: 0.084 },
    position: {
      x: 1, y: 0.894
    },
    anchor: 'bottomLeft'
  },
  s1_grass1: {
    size: { mode: 'heightFit', height: 0.154 },
    position: {
      x: 1, y: 1
    },
    anchor: 'bottomLeft'
  },
  s1_grass2: {
    size: { mode: 'heightFit', height: 0.485 },
    position: {
      x: 1, y: 1
    },
    anchor: 'bottomLeft'
  },
  s1_pole: {
    size: { mode: 'heightFit', height: 1 },
    position: 'topRight',
    anchor: 'topLeft'
  },
  s1_text: {
    size: { mode: 'heightFit', height: 885 / 2436 },
    position: { x: 764 / 1125, y: 342 / 2436 },
    anchor: 'topLeft'
  },
  s1_talk1: {
    size: { mode: 'heightFit', height: 0.162 },
    position: { x: 0.26, y: 0.57 },
    anchor: 'bottomRight'
  },
  s1_talk2: {
    size: { mode: 'heightFit', height: 0.19 },
    position: { x: 0.6, y: 0.52 },
    anchor: 'bottomLeft'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s1/sprites.js